<script>
    // ?id=9921&dnApp=1&dnAppVersion=6.5.5
    // ?id=9921&dnApp=1&dnAppVersion=6.5.5&darkMode=1
    import { onMount } from "svelte";
    import {
    baseUrl,
    getUrlVars,
    inIframe,
    inDNApp,
    handleMargins,
    handleDarkModeSettings,
    useDarkMode,
    isForcedColorMode 

    } from "../../../../scripts/loadExternalData";
    import { burstPostRatio } from "../../../../scripts/helpers.js";
    import Animation from "./components/StartAnimation.svelte";
    import Vote from "./components/Vote.svelte";
    import PlaySpotify from "./components/PlaySpotify.svelte";
    import PlayFile from "./components/PlayFile.svelte";
    import PlayFileMP3 from "./components/PlayMP3File.svelte";
    import { hasBeenVoted, answers, toplistL, listOfSelectedMelodies  } from './shared.js';
    import moment from 'moment';
    import 'moment/locale/sv';
  

  let notOver = false;

    let VoteRef = false;
    let PlayRef = false;
    let PlayFileRef = false;

    let hasVoted = false;
    // Prenumerera på ändringar i hasBeenVoted
    $: hasVoted = $hasBeenVoted;


    let currentAnswers = [];
    // Prenumerera på ändringar i answers
    $: currentAnswers = $answers;


    let topListLength = 3;
    // Prenumerera på ändringar i toplistL
    $: topListLength = $toplistL;


    let selectedMelody = [];
    // Prenumerera på ändringar i listOfSelectedMelodies
    $: selectedMelody = $listOfSelectedMelodies;



    let stopAnimation = false;

   let musiclist =  {

  "1": {
    "Titel": "pew pew pew",
    "Artist": "Cleo, Academics",
    "Album": "pew pew pew",
    "Datum": "2025-05-02",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/2bcafcd94738d6af689b618268cb041b53723f12",
    "URI": "spotify:track:317hcMaPmKb7WOZ20G7vJB",
    "ABC": 31
  },
  "2": {
    "Titel": "What Was That",
    "Artist": "Lorde",
    "Album": "Virgin",
    "Datum": "2025-06-27",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/2528a8496690f638d1a1a5e5eb66000071b2f2b2",
    "URI": "spotify:track:7hGCCQkdyF1MX6uk339uBS",
    "ABC": 48
  },
  "3": {
    "Titel": "I'm Your Dirt, I'm Your Love",
    "Artist": "Yung Lean",
    "Album": "Jonatan",
    "Datum": "2025-05-02",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/dfdc5ace3588c1ab6c867ddce290d0abf1ff7db4",
    "URI": "spotify:track:72CUf7pWNkykpZ5dUxdGlb",
    "ABC": 25
  },
  "4": {
    "Titel": "Berghain",
    "Artist": "ROSALÍA, Björk, Yves Tumor",
    "Album": "LUX",
    "Datum": "2025-11-07",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/5e4392849e9249bebf8fdf718e3227edc3a5cd79",
    "URI": "spotify:track:2T8yuUKl1nhmtaIocqWo4i",
    "ABC": 6
  },
  "5": {
    "Titel": "I Believe In Love",
    "Artist": "Baba Stiltz, Okay Kaya",
    "Album": "Blurb",
    "Datum": "2025-01-24",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/2433b207b4a07409d12aedc34c7ea58506ad7534",
    "URI": "spotify:track:0fecUhqxUBAXwDoeBD596a",
    "ABC": 23
  },
  "6": {
    "Titel": "DtMF",
    "Artist": "Bad Bunny",
    "Album": "DeBÍ TiRAR MáS FOToS",
    "Datum": "2025-01-05",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/e41ce6b82410d81c08baacca2a7169e5ace4287d",
    "URI": "spotify:track:3sK8wGT43QFpWrvNQsrQya",
    "ABC": 10
  },
  "7": {
    "Titel": "Tell me I never knew that",
    "Artist": "caroline, Caroline Polachek",
    "Album": "caroline 2",
    "Datum": "2025-05-30",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/d1ce77adb031a82cacb9769a8379b9cae1581834",
    "URI": "spotify:track:0p6WXZoqJ3eoV6G9WtL0o3",
    "ABC": 37
  },
  "8": {
    "Titel": "Våren",
    "Artist": "CIVIL POLIS, Leo leone",
    "Album": "Blåst av vinden",
    "Datum": "2025-04-04",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/5ccd4d23f9181365841f6721508ed052350b1dd2",
    "URI": "spotify:track:7iL5RHQMKQBKazL8hTLI6z",
    "ABC": 47
  },
  "9": {
    "Titel": "Save Me",
    "Artist": "Emma-Jean Thackray",
    "Album": "Weirdo",
    "Datum": "2025-04-25",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/6af261174bd5cf56f775f2eb57039873ccb25f61",
    "URI": "spotify:track:6cyceLjnnc8JzkhhqGTbGz",
    "ABC": 32
  },
  "10": {
    "Titel": "Henry, come on",
    "Artist": "Lana Del Rey",
    "Album": "Henry, come on",
    "Datum": "2025-04-11",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/e6dad05d1e3d98bb5bb02d4c9d5e3b6a9638f2f7",
    "URI": "spotify:track:6CYldrsUPBsiPtfLW4xZCl",
    "ABC": 20
  },
  "11": {
    "Titel": "Flood",
    "Artist": "Little Simz, Obongjayar, Moonchild Sanelly",
    "Album": "Lotus",
    "Datum": "2025-06-06",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/bd0a6a65b4657675fe2a0cf25d0a9bfb736be7ab",
    "URI": "spotify:track:3m9g8ua3M51JvqmS8rh6bS",
    "ABC": 16
  },
  "12": {
    "Titel": "Silverregn",
    "Artist": "Lisa Nilsson",
    "Album": "Uteblivna vi",
    "Datum": "2025-03-21",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/758b560ff847988cedd834bbec049b711f3ba50a",
    "URI": "spotify:track:5WCAihSUWBhnJKPIUZa7rj",
    "ABC": 33
  },
  "13": {
    "Titel": "Sweet Danger",
    "Artist": "Obongjayar",
    "Album": "Paradise Now",
    "Datum": "2025-05-30",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/43befedb5567b2fa40419e083c876fc7b5ad4123",
    "URI": "spotify:track:4KtomzdHDbrwTApmqEaCc7",
    "ABC": 34
  },
  "14": {
    "Titel": "take me by the hand",
    "Artist": "Oklou, Bladee",
    "Album": "choke enough",
    "Datum": "2025-02-07",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/017f4f6a690936ea10053dd86be0553f906407e5",
    "URI": "spotify:track:1oo8xwvtRep4Frhrpte5Eg",
    "ABC": 36
  },
  "15": {
    "Titel": "Got to Have Love",
    "Artist": "Pulp",
    "Album": "More",
    "Datum": "2025-06-06",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/22e2226dc66ba726dde496f3bf8402c7da10ae96",
    "URI": "spotify:track:4Z6rhg5FOWidgYhJ2Masw6",
    "ABC": 17
  },
  "16": {
    "Titel": "Manchild",
    "Artist": "Sabrina Carpenter",
    "Album": "Manchild",
    "Datum": "2025-06-05",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/37c21b6b0df9b7156527d0729a58b6db37c88a0a",
    "URI": "spotify:track:42UBPzRMh5yyz0EDPr6fr1",
    "ABC": 29
  },
  "17": {
    "Titel": "Uno II",
    "Artist": "Viagra Boys",
    "Album": "viagr aboys",
    "Datum": "2025-04-25",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/42ac10b2ebc43cbc4603be6a7466396285f9cba3",
    "URI": "spotify:track:4GCXxLQnqf6pP6SI7ljbZV",
    "ABC": 44
  },
  "18": {
    "Titel": "Love Doctor's",
    "Artist": "Yasin, Sexmane",
    "Album": "Love Doctor's",
    "Datum": "2025-02-21",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/eb4ac0105c352f907dd66f0a1d4dc025466490df",
    "URI": "spotify:track:0xNPb3enPEZLlW5JavgTvm",
    "ABC": 28
  },
  "19": {
    "Titel": "The Field (feat. The Durutti Column, Tariq Al-Sabir, Caroline Polachek & Daniel Caesar)",
    "Artist": "Blood Orange, Tariq Al-Sabir, Caroline Polachek, Daniel Caesar, The Durutti Column",
    "Album": "Essex Honey",
    "Datum": "2025-08-29",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/653060cd0769dc2c1382416792cd632d8e3eb0c3",
    "URI": "spotify:track:1XMBjGYUakFEjI4ZaISVt2",
    "ABC": 39
  },
  "20": {
    "Titel": "Chains & Whips",
    "Artist": "Clipse, Kendrick Lamar, Pharrell Williams, Pusha T, Malice",
    "Album": "Let God Sort Em Out",
    "Datum": "2025-07-11",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/3d3a6c557c3574dbe163e3b5bf3916bfaf7ce48c",
    "URI": "spotify:track:3znSvEwBq09We4cxxmwlZM",
    "ABC": 7
  },
  "21": {
    "Titel": "Don't Tap That Glass / Tweakin'",
    "Artist": "Tyler, The Creator",
    "Album": "DON'T TAP THE GLASS",
    "Datum": "2025-07-21",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/52becbbcc9800e9c5d25c09a557df4f1625e8225",
    "URI": "spotify:track:5DRS7YEe1bwGJLDGviT3CD",
    "ABC": 9
  },
  "22": {
    "Titel": "The Iconoclast",
    "Artist": "Anna von Hausswolff",
    "Album": "ICONOCLASTS",
    "Datum": "2025-10-31",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/687c3af0df22672e92c9fb283e622a1ba1186de7",
    "URI": "spotify:track:1RDzKhuTUKoGZ0XVnnyyxQ",
    "ABC": 40
  },
  "23": {
    "Titel": "EURO-COUNTRY",
    "Artist": "CMAT",
    "Album": "EURO-COUNTRY",
    "Datum": "2025-08-29",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/287761344f23edb9fcaaf883b056f603f0c999a3",
    "URI": "spotify:track:22vRKcdPjVW7Q6ydLNcYBV",
    "ABC": 11
  },
  "24": {
    "Titel": "Because We Built It",
    "Artist": "John Maus",
    "Album": "Later Than You Think",
    "Datum": "2025-09-26",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/56a6e14d380b6739024933de6fd6449251dac056",
    "URI": "spotify:track:3Qv9irQWmhbYFKR13d0dJ5",
    "ABC": 4
  },
  "25": {
    "Titel": "Eurosummer",
    "Artist": "Zara Larsson",
    "Album": "Midnight Sun",
    "Datum": "2025-09-26",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/14ddcaa1d9f8009286b2f85f929e8e4319bfae36",
    "URI": "spotify:track:2EhJHJV7itLmFGH1CQoK3i",
    "ABC": 12
  },
  "26": {
    "Titel": "How Much Is the World",
    "Artist": "Molly Nilsson",
    "Album": "Amateur",
    "Datum": "2025-10-01",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/f32436b1e32953177b321d73137511f739ecbafb",
    "URI": "spotify:track:1KJYPv44grXvBLGWLosfKa",
    "ABC": 22
  },
  "27": {
    "Titel": "Vi barn från Jedwabne",
    "Artist": "Gabel/Ossler, Ossler, Christian Gabel",
    "Album": "Gabel/Ossler",
    "Datum": "2025-10-03",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/6df75dabc94bd59a41c19f534ede4320798aef87",
    "URI": "spotify:track:1IbXrUHUrifiA1GfV5zoPz",
    "ABC": 46
  },
  "28": {
    "Titel": "Beg For Me",
    "Artist": "Lily Allen",
    "Album": "West End Girl",
    "Datum": "2025-10-24",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/0eaaf31985a684e58772a9d6359bc2f2b7315d5e",
    "URI": "spotify:track:66iAwSVdlwIV1JJDNcFE6s",
    "ABC": 5
  },
  "29": {
    "Titel": "USA Baby",
    "Artist": "Elias Rønnenfelt",
    "Album": "Speak Daggers",
    "Datum": "2025-10-17",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/2981fa526ecf451bbc3e816524fcb9d900e2b4df",
    "URI": "spotify:track:38GUplvx5Qxv0xMjFFygKB",
    "ABC": 45
  },
  "30": {
    "Titel": "Yup",
    "Artist": "Hannes",
    "Album": "Yup",
    "Datum": "2025-10-27",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/d41bceb1b4827bd22e4df09321a5c37f0bc4985f",
    "URI": "spotify:track:70pfTEWs5Z7K6bBkR8JyNi",
    "ABC": 50
  },
  "31": {
    "Titel": "The View Is Watching",
    "Artist": "Christian Kjellvander",
    "Album": "Ex Voto / The Silent Love",
    "Datum": "2025-10-31",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/36532c6ac607401592c93dd1642977a7f072ea12",
    "URI": "spotify:track:3ut7BzEvIOzo5mHyMlg810",
    "ABC": 41
  },
  "32": {
    "Titel": "Beautiful Strangers",
    "Artist": "Mavis Staples",
    "Album": "Sad And Beautiful World",
    "Datum": "2025-11-07",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/ef3867c14f571f80d2004939d13360fdcd447d8f",
    "URI": "spotify:track:3JCNSJUl4zyugzIdf6y71n",
    "ABC": 3
  },
  "33": {
    "Titel": "Three Piece Suit (feat. Azekel)",
    "Artist": "Kokoroko, Azekel",
    "Album": "Tuff Times Never Last",
    "Datum": "2025-07-11",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/dc7ceb41369c5f8d41488f86a0a109dbb9b6873d",
    "URI": "spotify:track:1NXiPP4aOE4fbyneVwpjQI",
    "ABC": 42
  },
  "34": {
    "Titel": "I DON'T NEED YOU, SO YOU COULD TELL ME IF I'M GUD",
    "Artist": "KABEAUSHÉ",
    "Album": "WE HAVE OURSELVES A SHEKDOWN",
    "Datum": "2025-11-28",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/f12b4075159cacd1d75f14f7c1f0567a39df59ea",
    "URI": "spotify:track:0QEfWuKltp4PR426fEjGBQ",
    "ABC": 24
  },
  "35": {
    "Titel": "The Fate of Ophelia",
    "Artist": "Taylor Swift",
    "Album": "The Life of a Showgirl",
    "Datum": "2025-10-03",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/08d084852368db5ef64c30ae9281d66a610b0605",
    "URI": "spotify:track:53iuhJlwXhSER5J2IYYv1W",
    "ABC": 38
  },
  "36": {
    "Titel": "You got time and I got money",
    "Artist": "Smerz",
    "Album": "Big city life",
    "Datum": "2025-05-23",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/fd79852a591befd5a649dd4431a734415d86300b",
    "URI": "spotify:track:0il7LJ828XyPqyvNx9cF5S",
    "ABC": 49
  },
  "37": {
    "Titel": "Sweethearts",
    "Artist": "Håkan Hellström",
    "Album": "Svensk Rost",
    "Datum": "2025-10-16",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/46e5c5b678fe8b1770f6b4cb0c26bb38d4f21ea5",
    "URI": "spotify:track:3CtOt1HRNiMIDVVp1D2JRn",
    "ABC": 35
  },
  "38": {
    "Titel": "Headphones On",
    "Artist": "Addison Rae",
    "Album": "Addison",
    "Datum": "2025-06-06",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/8a5245c87bcb491a31e966af3119606c1416d4b4",
    "URI": "spotify:track:3H6xZgwRZx8McVUJzmMxWe",
    "ABC": 19
  },
  "39": {
    "Titel": "Incomprehensible",
    "Artist": "Big Thief",
    "Album": "Double Infinity",
    "Datum": "2025-09-05",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/9727b1dff177a78e9e5e9b128683a9722badfca4",
    "URI": "spotify:track:5GTRE7cnySeaYBanwM5FIt",
    "ABC": 27
  },
  "40": {
    "Titel": "HIGHER!",
    "Artist": "Dijon",
    "Album": "Baby",
    "Datum": "2025-08-15",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/7e625e878273a4114d6803e287c76ee43c2c7508",
    "URI": "spotify:track:0XnD9GJRD01wvXFLWJXiYx",
    "ABC": 21
  },
  "41": {
    "Titel": "About Time",
    "Artist": "Cate Le Bon",
    "Album": "Michelangelo Dying",
    "Datum": "2025-09-26",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/387577d99edee35f56297830cc048fcfa044d682",
    "URI": "spotify:track:6woQykg1YFKSvRw1xwzJJX",
    "ABC": 2
  },
  "42": {
    "Titel": "father",
    "Artist": "Jim Legxacy",
    "Album": "black british music (2025)",
    "Datum": "2025-07-18",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/04e1ff4629b2ad611845d5b9d61981abab03e883",
    "URI": "spotify:track:2UTCHLFOZxvZUC7EDdYdjZ",
    "ABC": 13
  },
  "43": {
    "Titel": "A BUG'S LIFE",
    "Artist": "Sudan Archives",
    "Album": "THE BPM",
    "Datum": "2025-10-17",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/6faa82b9416f330f2936ab4d740a14a026f45adf",
    "URI": "spotify:track:1D7qrNAEbZ0G4oR6YZTvFK",
    "ABC": 1
  },
  "44": {
    "Titel": "touch me right",
    "Artist": "Raghd",
    "Album": "touch me right",
    "Datum": "2025-10-24",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/7e1d39427d45276f4bf95d2ff398ec9b30ff89f9",
    "URI": "spotify:track:4Yl0KI8Vglg2lqCFZrAkVE",
    "ABC": 43
  },
  "45": {
    "Titel": "Feel",
    "Artist": "Sunnan",
    "Album": "Feel / Tranan",
    "Datum": "2025-05-23",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/75a0b5c86ef389350a00c95c5edd168ff357b528",
    "URI": "spotify:track:2Y0JncmzHZWCsdvLoeEssP",
    "ABC": 14
  },
  "46": {
    "Titel": "CUT UP",
    "Artist": "SAILORR",
    "Album": "FROM FLORIDA'S FINEST",
    "Datum": "2025-05-09",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/abe38a94a5aa133f22d99aaed8dcfbf0e11fec39",
    "URI": "spotify:track:68aYtH4NsGGp331mVDIVCC",
    "ABC": 8
  },
  "47": {
    "Titel": "One Thing",
    "Artist": "Lola Young",
    "Album": "I’m Only F**king Myself",
    "Datum": "2025-09-19",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/747d1629d17c511a233345bef7db9a462fb1b2b3",
    "URI": "spotify:track:1xtGpjlpfU9ILjlxUa7UHl",
    "ABC": 30
  },
  "48": {
    "Titel": "First Last Dance",
    "Artist": "Joy Crookes",
    "Album": "Juniper",
    "Datum": "2025-09-19",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/08b82c7b76db38845f60d74a5a956b578b174be1",
    "URI": "spotify:track:2tE28bQYBZFOspAgqPGsJq",
    "ABC": 15
  },
  "49": {
    "Titel": "Illegal Hit",
    "Artist": "Yttling Jazz",
    "Album": "Illegal Hit",
    "Datum": "2025-09-26",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/522decaca6b9f2487ea58cb45ba218b098264113",
    "URI": "spotify:track:0M7WI5rF4k2Y8IbmMcaQwb",
    "ABC": 26
  },
  "50": {
    "Titel": "GUSTO",
    "Artist": "Boko Yout",
    "Album": "GUSTO",
    "Datum": "2025-09-05",
    "Start": "",
    "Stop": "",
    "PreviewUrl": "https://p.scdn.co/mp3-preview/7cd29c94998b812576eefa7ff7aeb00a0cac2fd2",
    "URI": "spotify:track:3DzgoqqPwtCxvyqKCj9hq7",
    "ABC": 18
  }
};

let musiclistX = {
  "1": {
    "Titel": "pew pew pew",
    "Artist": "Cleo, Academics",
    "Album": "pew pew pew",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:317hcMaPmKb7WOZ20G7vJB",
    "ABC": 31
  },
  "2": {
    "Titel": "What Was That",
    "Artist": "Lorde",
    "Album": "Virgin",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:7hGCCQkdyF1MX6uk339uBS",
    "ABC": 48
  },
  "3": {
    "Titel": "I'm Your Dirt, I'm Your Love",
    "Artist": "Yung Lean",
    "Album": "Jonatan",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:72CUf7pWNkykpZ5dUxdGlb",
    "ABC": 25
  },
  "4": {
    "Titel": "Berghain",
    "Artist": "ROSALÍA, Björk, Yves Tumor",
    "Album": "LUX",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:2T8yuUKl1nhmtaIocqWo4i",
    "ABC": 6
  },
  "5": {
    "Titel": "I Believe In Love",
    "Artist": "Baba Stiltz, Okay Kaya",
    "Album": "Blurb",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:0fecUhqxUBAXwDoeBD596a",
    "ABC": 23
  },
  "6": {
    "Titel": "DtMF",
    "Artist": "Bad Bunny",
    "Album": "DeBÍ TiRAR MáS FOToS",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:3sK8wGT43QFpWrvNQsrQya",
    "ABC": 10
  },
  "7": {
    "Titel": "Tell me I never knew that",
    "Artist": "caroline, Caroline Polachek",
    "Album": "caroline 2",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:0p6WXZoqJ3eoV6G9WtL0o3",
    "ABC": 37
  },
  "8": {
    "Titel": "Våren",
    "Artist": "CIVIL POLIS, Leo leone",
    "Album": "Blåst av vinden",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:7iL5RHQMKQBKazL8hTLI6z",
    "ABC": 47
  },
  "9": {
    "Titel": "Save Me",
    "Artist": "Emma-Jean Thackray",
    "Album": "Weirdo",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:6cyceLjnnc8JzkhhqGTbGz",
    "ABC": 32
  },
  "10": {
    "Titel": "Henry, come on",
    "Artist": "Lana Del Rey",
    "Album": "Henry, come on",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:6CYldrsUPBsiPtfLW4xZCl",
    "ABC": 20
  },
  "11": {
    "Titel": "Flood",
    "Artist": "Little Simz, Obongjayar, Moonchild Sanelly",
    "Album": "Lotus",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:3m9g8ua3M51JvqmS8rh6bS",
    "ABC": 16
  },
  "12": {
    "Titel": "Silverregn",
    "Artist": "Lisa Nilsson",
    "Album": "Uteblivna vi",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:5WCAihSUWBhnJKPIUZa7rj",
    "ABC": 33
  },
  "13": {
    "Titel": "Sweet Danger",
    "Artist": "Obongjayar",
    "Album": "Paradise Now",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:4KtomzdHDbrwTApmqEaCc7",
    "ABC": 34
  },
  "14": {
    "Titel": "take me by the hand",
    "Artist": "Oklou, Bladee",
    "Album": "choke enough",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:1oo8xwvtRep4Frhrpte5Eg",
    "ABC": 36
  },
  "15": {
    "Titel": "Got to Have Love",
    "Artist": "Pulp",
    "Album": "More",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:4Z6rhg5FOWidgYhJ2Masw6",
    "ABC": 17
  },
  "16": {
    "Titel": "Manchild",
    "Artist": "Sabrina Carpenter",
    "Album": "Manchild",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:42UBPzRMh5yyz0EDPr6fr1",
    "ABC": 29
  },
  "17": {
    "Titel": "Uno II",
    "Artist": "Viagra Boys",
    "Album": "viagr aboys",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:4GCXxLQnqf6pP6SI7ljbZV",
    "ABC": 44
  },
  "18": {
    "Titel": "Love Doctor's",
    "Artist": "Yasin, Sexmane",
    "Album": "Love Doctor's",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:0xNPb3enPEZLlW5JavgTvm",
    "ABC": 28
  },
  "19": {
    "Titel": "The Field (feat. The Durutti Column, Tariq Al-Sabir, Caroline Polachek & Daniel Caesar)",
    "Artist": "Blood Orange, Tariq Al-Sabir, Caroline Polachek, Daniel Caesar, The Durutti Column",
    "Album": "Essex Honey",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:1XMBjGYUakFEjI4ZaISVt2",
    "ABC": 39
  },
  "20": {
    "Titel": "Chains & Whips",
    "Artist": "Clipse, Kendrick Lamar, Pharrell Williams, Pusha T, Malice",
    "Album": "Let God Sort Em Out",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:3znSvEwBq09We4cxxmwlZM",
    "ABC": 7
  },
  "21": {
    "Titel": "Don't Tap That Glass / Tweakin'",
    "Artist": "Tyler, The Creator",
    "Album": "DON'T TAP THE GLASS",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:5DRS7YEe1bwGJLDGviT3CD",
    "ABC": 9
  },
  "22": {
    "Titel": "The Iconoclast",
    "Artist": "Anna von Hausswolff",
    "Album": "ICONOCLASTS",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:1RDzKhuTUKoGZ0XVnnyyxQ",
    "ABC": 40
  },
  "23": {
    "Titel": "EURO-COUNTRY",
    "Artist": "CMAT",
    "Album": "EURO-COUNTRY",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:22vRKcdPjVW7Q6ydLNcYBV",
    "ABC": 11
  },
  "24": {
    "Titel": "Because We Built It",
    "Artist": "John Maus",
    "Album": "Later Than You Think",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:3Qv9irQWmhbYFKR13d0dJ5",
    "ABC": 4
  },
  "25": {
    "Titel": "Eurosummer",
    "Artist": "Zara Larsson",
    "Album": "Midnight Sun",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:2EhJHJV7itLmFGH1CQoK3i",
    "ABC": 12
  },
  "26": {
    "Titel": "How Much Is the World",
    "Artist": "Molly Nilsson",
    "Album": "Amateur",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:1KJYPv44grXvBLGWLosfKa",
    "ABC": 22
  },
  "27": {
    "Titel": "Vi barn från Jedwabne",
    "Artist": "Gabel/Ossler, Ossler, Christian Gabel",
    "Album": "Gabel/Ossler",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:1IbXrUHUrifiA1GfV5zoPz",
    "ABC": 46
  },
  "28": {
    "Titel": "Beg For Me",
    "Artist": "Lily Allen",
    "Album": "West End Girl",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:66iAwSVdlwIV1JJDNcFE6s",
    "ABC": 5
  },
  "29": {
    "Titel": "USA Baby",
    "Artist": "Elias Rønnenfelt",
    "Album": "Speak Daggers",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:38GUplvx5Qxv0xMjFFygKB",
    "ABC": 45
  },
  "30": {
    "Titel": "Yup",
    "Artist": "Hannes",
    "Album": "Yup",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:70pfTEWs5Z7K6bBkR8JyNi",
    "ABC": 50
  },
  "31": {
    "Titel": "The View Is Watching",
    "Artist": "Christian Kjellvander",
    "Album": "Ex Voto / The Silent Love",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:3ut7BzEvIOzo5mHyMlg810",
    "ABC": 41
  },
  "32": {
    "Titel": "Beautiful Strangers",
    "Artist": "Mavis Staples",
    "Album": "Sad And Beautiful World",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:3JCNSJUl4zyugzIdf6y71n",
    "ABC": 3
  },
  "33": {
    "Titel": "Three Piece Suit (feat. Azekel)",
    "Artist": "Kokoroko, Azekel",
    "Album": "Tuff Times Never Last",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:1NXiPP4aOE4fbyneVwpjQI",
    "ABC": 42
  },
  "34": {
    "Titel": "I DON'T NEED YOU, SO YOU COULD TELL ME IF I'M GUD",
    "Artist": "KABEAUSHÉ",
    "Album": "WE HAVE OURSELVES A SHEKDOWN",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:0QEfWuKltp4PR426fEjGBQ",
    "ABC": 24
  },
  "35": {
    "Titel": "The Fate of Ophelia",
    "Artist": "Taylor Swift",
    "Album": "The Life of a Showgirl",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:53iuhJlwXhSER5J2IYYv1W",
    "ABC": 38
  },
  "36": {
    "Titel": "You got time and I got money",
    "Artist": "Smerz",
    "Album": "Big city life",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:0il7LJ828XyPqyvNx9cF5S",
    "ABC": 49
  },
  "37": {
    "Titel": "Sweethearts",
    "Artist": "Håkan Hellström",
    "Album": "Svensk Rost",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:3CtOt1HRNiMIDVVp1D2JRn",
    "ABC": 35
  },
  "38": {
    "Titel": "Headphones On",
    "Artist": "Addison Rae",
    "Album": "Addison",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:3H6xZgwRZx8McVUJzmMxWe",
    "ABC": 19
  },
  "39": {
    "Titel": "Incomprehensible",
    "Artist": "Big Thief",
    "Album": "Double Infinity",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:5GTRE7cnySeaYBanwM5FIt",
    "ABC": 27
  },
  "40": {
    "Titel": "HIGHER!",
    "Artist": "Dijon",
    "Album": "Baby",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:0XnD9GJRD01wvXFLWJXiYx",
    "ABC": 21
  },
  "41": {
    "Titel": "About Time",
    "Artist": "Cate Le Bon",
    "Album": "Michelangelo Dying",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:6woQykg1YFKSvRw1xwzJJX",
    "ABC": 2
  },
  "42": {
    "Titel": "father",
    "Artist": "Jim Legxacy",
    "Album": "black british music (2025)",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:2UTCHLFOZxvZUC7EDdYdjZ",
    "ABC": 13
  },
  "43": {
    "Titel": "A BUG'S LIFE",
    "Artist": "Sudan Archives",
    "Album": "THE BPM",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:1D7qrNAEbZ0G4oR6YZTvFK",
    "ABC": 1
  },
  "44": {
    "Titel": "touch me right",
    "Artist": "Raghd",
    "Album": "touch me right",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:4Yl0KI8Vglg2lqCFZrAkVE",
    "ABC": 43
  },
  "45": {
    "Titel": "Feel",
    "Artist": "Sunnan",
    "Album": "Feel / Tranan",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:2Y0JncmzHZWCsdvLoeEssP",
    "ABC": 14
  },
  "46": {
    "Titel": "CUT UP",
    "Artist": "SAILORR",
    "Album": "FROM FLORIDA'S FINEST",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:68aYtH4NsGGp331mVDIVCC",
    "ABC": 8
  },
  "47": {
    "Titel": "One Thing",
    "Artist": "Lola Young",
    "Album": "I’m Only F**king Myself",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:1xtGpjlpfU9ILjlxUa7UHl",
    "ABC": 30
  },
  "48": {
    "Titel": "First Last Dance",
    "Artist": "Joy Crookes",
    "Album": "Juniper",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:2tE28bQYBZFOspAgqPGsJq",
    "ABC": 15
  },
  "49": {
    "Titel": "Illegal Hit",
    "Artist": "Yttling Jazz",
    "Album": "Illegal Hit",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:0M7WI5rF4k2Y8IbmMcaQwb",
    "ABC": 26
  },
  "50": {
    "Titel": "GUSTO",
    "Artist": "Boko Yout",
    "Album": "GUSTO",
    "Datum": "",
    "Start": "",
    "Stop": "",
    "URI": "spotify:track:3DzgoqqPwtCxvyqKCj9hq7",
    "ABC": 18
  }
};


  
    export const state = {
      darkMode:false,
      appDarkMode:false,
      darkModeSettings:'Följ användarens tema',
    }

    let myRenderDarkMode = getUrlVars().darkMode === '0';
    let myRenderForcedColorMode = false;


    let isPlayingMelody = [];
    let isSoundReady = true;
    let hideSoundBar = false;
    let hideVoteBar = false;

    let isWatingForSound = false;

    let scrollableDiv = '';
    let debugstring   = 'debug 14 <br>';
    let debugasmobile   = getUrlVars().debugasmobile  === '1';
    let debugasmobile2   = getUrlVars().debugasmobile2  === '1';

    let tinyscreen    = false; 
    let fullscreen    = false;
    let onRealWeb     = false;
    let webscreen = getUrlVars().webscreen  === '1';
    let initVote = false;

    let isClicked = [];

    for (let i = 0; i < 51; i++) {
        isClicked[i] = false;
    }

    onMount(async() => {
burstPostRatio();
    if (notOver){

        scrollableDiv = document.getElementById('voteScroller');

        scrollableDiv.addEventListener('scroll', checkScroll);
     
        burstPostRatio();
   
  
      if(!inIframe()) {

        document.getElementsByTagName('body')[0].style.overflow = 'auto';
        document.getElementsByTagName('body')[0].style.margin = '0';
       
      } else {

        if(window.innerWidth <= 620) {
          document.getElementsByTagName('body')[0].style.margin = '0';
        }

      }

      if(!inDNApp()){
        onRealWeb = true;
      } else {
        onRealWeb = false;
      }
      // console.log( 'on real');
      // console.log( onRealWeb);

      fullscreen = !webscreen; 

      debugstring = `${debugstring}  <span>onRealWeb: ${onRealWeb} </span><br>`;
      debugstring = `${debugstring}  <span>fullscreen: ${fullscreen} </span><br>`;
      debugstring = `${debugstring}  <span>webscreen: ${webscreen} </span><br>`;

      if(document.getElementsByTagName('body')[0].offsetWidth <= 479) {
        tinyscreen = true;
      } else {
        tinyscreen = false;
      }


      /* ----------------------- */
      /*    Debugkod   */

        if(debugasmobile) {
          console.log('debugasmobile');
          fullscreen = true;
          onRealWeb = false;
        } 
        
        if( debugasmobile2){

          console.log('debugasmobile2');
          fullscreen = false;
          onRealWeb = false;

        }
    
      /* ----------------------- */
      /* Debugkod    */
    
      

      // handle darkmode
      handleDarkModeSettings(state.appDarkMode,state.darkMode,state.darkModeSettings);
      
      myRenderDarkMode = useDarkMode();
     
      myRenderForcedColorMode = isForcedColorMode();

      if ( myRenderDarkMode ) {
        document.getElementsByTagName("body")[0].classList.add("body__dark-mode");
      } else {
        document.getElementsByTagName("body")[0].classList.add("body__light-mode");
      } 

      burstPostRatio();

        //initSpotify();
        //checkSpotifyEmbedController();

      if(fullscreen || onRealWeb){

        //console.log('stop animation');

        stopAnimation = true;
        initVote = true;

      }

      

    }
    }); // on mount




function callRegistrerSelection(idx) {
        // console.log('välj låten');
        if (VoteRef) {
            const executor = VoteRef.registrerSelection(idx); // Anropa första nivån
            executor(); // Kör den inre funktionen
        }
}

function callPlayMelody(idx) {

        isClicked[idx] = true;

        // console.log('spela låten');

        if (PlayRef) {
            const executor = PlayRef.playMelodySpotify(idx); // Anropa första nivån
            executor(); // Kör den inre funktionen
        }

        if (PlayFileRef) {
            const executor = PlayFileRef.playMelody(idx); // Anropa första nivån
            executor(); // Kör den inre funktionen
        }





        setTimeout(() => {
          for (let i = 0; i < 51; i++) {
              isClicked[i] = false;
          }
        }, 500);

        // console.log(isPlayingMelody);
}


function scrollToTop() {
  
  // console.log('scrolltop');
  // console.log(scrollableDiv.scrollTop);

  //const scrollableDiv = document.getElementById('scrollableDiv'); // Din scrollbara div
  const targetPosition = 210; // Målet för scrollningen
  const startPosition = scrollableDiv.scrollTop; // Nuvarande scrollposition
  const duration = 1500; // Scrolltid i millisekunder
  const distance = targetPosition - startPosition; // Avståndet som ska scrollas
  let startTime = null;

  function s_animation(currentTime) {
    if (startTime === null) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const run = easeInOutQuad(timeElapsed, startPosition, distance, duration);
    scrollableDiv.scrollTop = run;
    if (timeElapsed < duration) {
      requestAnimationFrame(s_animation);
    }
  }

  function easeInOutQuad(t, b, c, d) {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  }

  requestAnimationFrame(s_animation);
}

    // Funktion för att kolla om sidan är i toppen
function checkScroll() {

        if (scrollableDiv.scrollTop <= 250) {
            hideSoundBar = true; 
        }  else {
          hideSoundBar = false; 
        }

      if (scrollableDiv.scrollTop <= 900) {
            hideVoteBar = true;
        } else {
          hideVoteBar = false;
        }
}


$: if (currentAnswers.length >= topListLength) {

// console.log('scroll');
  
scrollToTop();

}


function closeFullScreen() {

  let cmd = 'fullscreenEnd';
  let args = {};

  if (window.ReactNativeWebView) {

      window.ReactNativeWebView.postMessage(JSON.stringify({
      cmd: cmd,
      args: args
      }));
  }
}






  </script>

<svg width="0" height="0" viewBox="0 0 100 2000" xmlns="http://www.w3.org/2000/svg"  style="position: absolute;">

  <!-- Ljuskägla med elliptisk topp och spetsig botten -->
  <defs>
  <clipPath id="lightBeamClip">
  <path d="
    M 100,0
    A 70,40 0 0 1 160,40
    L 120,2000
    L 80,2000
    L 40,40
    A 70,40 0 0 1 100,0
    Z" 
    transform="scale(0.5)"/>
          </clipPath>
    </defs>
</svg>

<svg xmlns="http://www.w3.org/2000/svg" style="display: none;">

 
    <symbol viewBox="0 0 24 24"  id="opensvg" >
        <polygon transform="translate(12.000000, 12.499990) rotate(-90.000000) translate(-12.000000, -12.499990) " points="16.4999898 2.49998976 6.49998976 12.5015898 16.4999898 22.4999898 17.5000102 21.4999898 8.49998976 12.5015898 17.5000102 3.49998976"></polygon>
    </symbol>
    
    <symbol viewBox="0 0 24 24"  id="closesvg" >
                <polygon  transform="translate(12.000000, 11.500000) rotate(-270.000000) translate(-12.000000, -11.500000) " points="6.5 11.5 16.5 21.5 17.5 20.5 8.5 11.5 17.5 2.5 16.5 1.5"></polygon>
    </symbol>
      
    <symbol viewBox="0 0 24 24" id="closeXsvg">
      <polygon points="20.0000 3.00000 12 11.00000 4.0001 3.00000 3.9999 3.00000 3 4.00000 11 12.00000 3 20.00000 4 21.00000 12 13.00000 20 21.00000 21 20.00000 13 12.00000 21 4.00000 20.0001 3.00000"></polygon>
    </symbol>


    <symbol viewBox="0 0 48 48" id="playXXsvg" >
      <path d="M6,4 L6,44 L42,24 L6,4 Z M8.9998,9.102 L35.8292,24 L8.9998,38.898 L8.9998,9.102 Z"></path>
    </symbol>

    <symbol viewBox="0 0 24 24" id="pauseXsvg" >

      <path d="M14 18.5v-13h3.75v13H14Zm-7.75 0v-13H10v13H6.25Z"></path>
    </symbol>

    <symbol id="ds-pause" viewBox="0 0 48 48">
      <path d="M14 18.5v-13h3.75v13H14Zm-7.75 0v-13H10v13H6.25Z"></path>
    </symbol>

    <symbol viewBox="0 0 24 24" id="ljud_on">
      <defs>
          <polygon id="path-1" points="5e-05 0 3 0 3 10 5e-05 10"></polygon>
      </defs>
      <g id="ljud_2" stroke="none" stroke-width="1" fill-rule="evenodd">
          <path d="M13,2 L6,7.9999 L2,7.9999 L2,15.9999 L6,15.9999 L13,22 L13,2 Z M3.5,9.5 L6,9.5 L6.5548,9.5 L6.9761,9.1389 L11.5,5.2613 L11.5,18.7287 L7.0113,14.8633 L6.5892,14.5 L6.0324,14.5 L3.5,14.5 L3.5,9.5 Z" id="Fill-1" ></path>
          <g id="Group-7" transform="translate(13.999930, 7.000000)">
              <g id="Group-4" transform="translate(2.000000, 0.000000)">
                  <mask id="mask-2" fill="white">
                      <use xlink:href="#path-1"></use>
                  </mask>
                  <g id="Clip-3"></g>
                  <path d="M1.00005,0 L5e-05,1 C0.98605,2.0485 1.60005,3.4505 1.60005,5 C1.60005,6.5495 0.98605,7.9515 5e-05,9 L1.00005,10 C2.23855,8.6984 3.00005,6.9386 3.00005,5 C3.00005,3.0614 2.23865,1.3016 1.00005,0" id="Fill-2"  mask="url(#mask-2)"></path>
              </g>
              <path d="M1.00005,2 L5e-05,3 C0.41105,3.5717 0.64755,4.262 0.64755,5 C0.64755,5.738 0.41105,6.4283 5e-05,7 L1.00005,8 C1.66005,7.1649 2.04755,6.1241 2.04755,5 C2.04755,3.8759 1.66005,2.8351 1.00005,2" id="Fill-5" ></path>
          </g>
      </g>
     </symbol>


     <symbol viewBox="0 0 24 24" id="ljud_off">
          <g id="ljud_stopp" stroke="none" stroke-width="1"  fill-rule="evenodd">
            <path d="M13,2 L6,7.9999 L2,7.9999 L2,15.9999 L6,15.9999 L13,22 L13,2 Z M3.5,9.5 L6.5549,9.5 L11.5,5.2613 L11.5,18.7288 L6.5894,14.5 L3.5,14.5 L3.5,9.5 Z" id="Fill-1" ></path>
            <polygon id="Fill-2"  points="18.00004 11 15 8 14 9 16.99994 12 14 15 15 16 18.00004 13 21 16 22 15 19.00004 12 22 9 21 8"></polygon>
        </g>
     </symbol>
    
     <symbol viewBox="0 0 24 24" id="playXsvg" >
      <path d="M8.42163 17.6869V5.48694L17.9966 11.5869L8.42163 17.6869Z"></path>
    </symbol>



</svg>

  <main
  class={`main__content-wrapper style2024 ${handleMargins() ? "main__normal-width" : "main__normal-width"} ${myRenderDarkMode ? "main__dark-mode" : "main__light-mode"} ${myRenderForcedColorMode ? "main__padded-top-bottom" : ""} ${handleMargins() ? 'main__full-width' : ''}`}
  >
{#if notOver }
  <div id="debugger">{@html debugstring}</div>
 
  <Animation 
  onRealWeb={onRealWeb}
  fullscreen={fullscreen}
  stopAnimation={stopAnimation}
   />


<div class="voteApp" class:onRealWeb={onRealWeb} class:fullscreen={fullscreen} >
  <div id="voteScroller" class="voteScroller">

    <div class="voteBoxCloser">
      <div class="voteBoxCloserWrapper" on:click={() =>closeFullScreen()} on:keydown={() =>closeFullScreen()}>
        <svg class="XsvgIconClose"><use xlink:href='#closeXsvg'/></svg>
      </div>
    </div>

  <div class="voteBoxLogo">
    <img src="local_assets/voteMusicChart2025/images/bg2.png" alt="logo" />
  </div>
  {#if initVote }
  <Vote
  bind:this={VoteRef}
  parentScrollToTop={scrollToTop}
  onRealWeb={onRealWeb}
  fullscreen={fullscreen}
  tinyscreen{tinyscreen}
  musiclist={musiclist}
  hideVoteBar={hideVoteBar}
  myRenderDarkMode={myRenderDarkMode}
   />
   {/if}
      
      <div class="musicList" class:collapse={hasVoted} class:disableVote={currentAnswers.length >= topListLength} >
        {#each Object.entries(musiclist) as [key, melody], index (key)}
        <div id="melody-{index+1}" class="melodyOuther" class:active={selectedMelody[index+1]}   style={`order:${melody.ABC}`} >
          <div class="melodyColorBox">
            <img class="album"  alt="eq" src={`local_assets/voteMusicChart2025/images/album/${index+1}.jpg`} />
            <div class="melodyItem">
                <div class="box1">
                  <div class="box1wrapper">
                    <div class="firstItem">{`"${melody.Titel}"`}</div>
                    <div class="smalltextdivider"></div>
                    <div class="secondItem">{melody.Artist}</div>
                    <div class="smalltextdivider"></div>
                    <div class="thirdItem">{melody.Album}</div>
                  </div>
                </div>
            </div>
            <div class="mellodyButtons" class:isPlaying={isPlayingMelody[index+1] === true || isPlayingMelody[index+1] === 1 || isPlayingMelody[index+1] === 2 } 
            class:isClicked={isClicked[index+1]}
            class:waiting={isWatingForSound === index+1}>
              <div class:showplayer={isSoundReady} class="mellodyPlayButton" on:click={() => callPlayMelody(index+1)} on:keydown={() => callPlayMelody(index+1)} >

                <div class="smalldivider"></div>
                <div class="buttonPlay"><div class="play-button"></div></div>
                <div class="buttonPause"><div class="pause-button"><div></div><div></div></div></div>
                <div class="mediumdivider"></div>
              </div>
              <div on:click={() => callRegistrerSelection(index+1)} on:keydown={() => callRegistrerSelection(index+1)} class="box3">Välj</div>  
            </div>  
          </div>
        </div>
        {/each}
      </div>
      {#if false }
      <PlaySpotify
      bind:this={PlayRef}
      bind:isSoundReady={isSoundReady}
      bind:isPlayingMelody={isPlayingMelody}
      fullscreen={fullscreen}
      onRealWeb={onRealWeb}
      musiclist={musiclist}
      hideSoundBar={hideSoundBar}
       />
       {/if}
      {#if true && !hasVoted}
 

        <PlayFileMP3
        bind:this={PlayFileRef}
        bind:isSoundReady={isSoundReady}
        bind:isPlayingMelody={isPlayingMelody}
        bind:isWatingForSound={isWatingForSound}
        fullscreen={fullscreen}
        onRealWeb={onRealWeb}
        musiclist={musiclist}
        hideSoundBar={hideSoundBar}
         />

        <div class="littledivider"></div>



        {/if}

       {#if false }
       <PlayFile
       bind:this={PlayFileRef}
       bind:isSoundReady={isSoundReady}
       bind:isPlayingMelody={isPlayingMelody}
       fullscreen={fullscreen}
       onRealWeb={onRealWeb}
       musiclist={musiclist}
       hideSoundBar={hideSoundBar}
        />
        {/if}

      <div class="voteBoxMess voteBoxMessPadding" class:enableVoteMessage={(currentAnswers.length >= topListLength) && !hasVoted}>
        <div>Du har nu valt tre låtar, scrolla upp till toppen för att rösta</div><div class="voteBoxArrow">↑</div>
      </div>    
    <div class="voteBoxLogo voteBoxLogoPadding"  class:hideme={hasVoted && fullscreen}>
      <img src="local_assets/voteMusicChart2025/images/bg2.png" alt="logo">
    </div>    
   <div class="standard-source">
    Urvalet har gjorts av DN:s musikredaktion. Listan innehåller låtar släppta mellan 1 december 2024 och 30 november 2025.
    <br>
   </div>


</div>    
</div>

{/if}
<div class="voteApp onRealWeb over">Röstningen är avslutad.</div>
</main>


<style global type="text/scss" lang="scss">

    :root {
        
      --text-color-melody:#EDEDED;
      --text-color-artist:#EDEDED;
      --text-color-album:#45666a;
      --text-color-date:#45666a;
      --text-color-dina-val:#ccc;
      --text-color-not-selected:#36545d;


      --list-text-size-large:2.1rem;
      --list-text-size-medium:1.8rem;
      --list-text-size-small:1.4rem;
    
      --bg-color-site:#345966;
      --bg-color-melody:#163b48;
      --bg-color-melody-selected:#0c2831;


      --melody--nr2-color:#ffeb00;
      --melody--nr1-colorXXX:#f69d00;
    
      --melody--nr1-color:#345966;
    
      --bg-color-play:#345966;
    
      --bg-color-vote:#345966;
    
      --mellody-height:7.4rem;
      --button-height:9rem;
    
    --selected-color:#ffeb00;
    }

    .style2024 {


      --text-color-vote-box:#EDEDED;
      --text-color-sound-box:#EDEDED;
      --text-color-melody:#222;
      --text-color-artist:#222;
      --text-color-album:#222;
      --text-color-date:#222;
      --text-color-dina-val:#ccc;
      --text-color-not-selected:#36545d;


      --bg-color-vote-box:#345966;
      --bg-color-site:#f0f0f0;
      --bg-color-list:#f0f0f0;
      --bg-color-melody:#ffffff;
      --bg-color-melody-selected:#0c2831;
      --bg-color-play:#000;
      --bg-color-pause:#000;
      --bg-color-vote:#da000d;
      --bg-color-sound-box:#345966;;

      --mellody-height:9rem;
      --mellody-button-height: 6rem;
      --button-height:9rem;
      --text-color-melody-button:#EDEDED;


      --box-padding-melody:1.5rem;

      --list-text-size-large:2.1rem;
      --list-text-size-medium:1.6rem;
      --list-text-size-small:1.6rem;

      --list-text-weight-large:700;
      --list-text-weight-medium:500;
      --list-text-weight-small:300;

      --divider-small:0rem;
      --divider-medium:2rem;

    }
    
      html,
      body {
        font-size: 2.4vw;
        background-color: #f2f2f2 !important;
      }
    
      body {
        margin: 0;
        padding: 0;
        line-height: 1.4;
        font-family: DNSansVF,Georgia,"Times New Roman",Times,serif;
        font-weight: 400;
        font-style: normal;
        font-stretch: normal;
      }
    
    
    main {
        background-color: transparent;
        max-width: 560px;
        min-width: 300px;
        position: relative;
        margin: 0 auto;
        transition: all 0.9s ease-in-out;
        box-sizing: border-box;
        padding:0;
        padding-top: 0;
        padding-bottom:0;
      }


    main.main__padded-top-bottom {
      padding:0;
      padding-top: 0;
      padding-bottom:0;
      margin: 0 auto;
    }
    
    
    .melodyOuther {
      position: relative;
      width: 100%;
      margin: 0;
      padding: 0;
      transition: all 0.9s ease-in-out; 
      background-color: transparent;
      padding-left: 0;
      padding-right: 0;
      box-sizing: border-box;
      z-index: 0;
    
    }
    .onRealWeb .melodyOuther {
      padding-left: 0.5rem;
      padding-right: 0.5rem;
    }

    .melodyColorBox {
      position: relative;
      width: 100%;
      margin: 0;
      padding: 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-content: flex-start;
      align-items: flex-start;
      background-color: var(--bg-color-melody);
      box-sizing: border-box;
      margin-top: 0.5rem;
      border-radius: 0px;
      border: 1px solid transparent;
      padding-left: var(--box-padding-melody);
      padding-right: 0rem;
      padding-top: var(--box-padding-melody);
      padding-bottom: var(--box-padding-melody);
    
    }
    
    
    .musicList {
    position: relative;
    width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-content: flex-start;
      align-items: flex-start;
      margin-bottom: 1rem;
      background-color: var(--bg-color-list);
    
    }
    
    .musicList.collapse {
      margin-bottom: 0;
    }
    
    .melodyItem {
      position: relative;
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-content: center;
      align-items: center;
      height:var(--mellody-height);
      height:unset;
      background-color: transparent;
      padding:0;
      box-sizing: border-box;
      color:var(--text-color-melody);
      transition: all 0.3s ease-in-out;
      overflow: hidden;
      cursor: pointer;
    }
    
    .melodyOuther.active .melodyColorBox {
      background-colorx: var(--bg-color-melody-selected);
      backgroundx: linear-gradient( var(--bg-color-melody), var(--bg-color-melody-selected));
      border-left: 5px solid var(--bg-color-vote);
    }
    
    .musicList.collapse .mellodyButtons {
    
        height: 0;
        padding: 0;
        margin: 0;
        overflow:hidden;
    
    }
    
    .musicList.collapse .melodyColorBox {
     border: 0px solid #000;
     height: 0;
     padding: 0;
     margin: 0;
     overflow:hidden;
    }
    
    .musicList.collapse .melodyItem {
    
    height: 0;
    padding: 0;
    margin: 0;
    
    }
    
    
    .musicList.disableVote .melodyOuther {
    
        opacity:0.5;
        filter: grayscale(100%);
        pointer-events: none;
    }
    
    
    .spotify-wrapper {
      position: relative;
      width: 100%;
      height: 80px;
      overflow: hidden;
      margin: 0;
      margin-top:0rem;
      padding: 0;
      filter: grayscale(100%);
    }
    
    .musicList.collapse .spotify-wrapper {
      height: 0;
      margin-top:0;
    }
    .mellodyButtons {
      position: relative;
      width:100%;
      padding: 0;
      padding-left: 0rem;
      margin: 0;
      display: flex;
      margin-top: 0;
      background-color: transparent;
      height:var(--mellody-button-height);
      box-sizing: border-box;
      flex-direction: row;
      justify-content: flex-start;
      align-content: center;
      align-items: center;
      gap:2rem;
    }

    .mellodyPlayButton {
      flex-direction: row;
      justify-content: flex-start;
      align-content: flex-start;
      align-items: flex-start;
      display: none;
      cursor: pointer;
      
    }

    .mellodyPlayButton.showplayer  {
      display: flex;
    }

    .buttonPlayX{
      width: 3rem;
      height: 3rem;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-content: center;
      align-items: center;
      background-color: var(--bg-color-play);
      border-radius: 50%;
    
    }

    .buttonPlay {font-size: 0.8rem;}

    .play-button {
      position: relative;
      width: 5em;
      height: 5em;
      background-color: var(--bg-color-play);
      border-radius: 50%; /* Makes it a circle */
      display: flex;
      justify-content: center;
      align-items: center;
      box-shadowx: 0 0.4em 0.8em rgba(0, 0, 0, 0.2);
    
    }

    .play-button::after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 1.25em 0 1.25em 2.08em; /* Triangle size in em */
    border-color: transparent transparent transparent white; /* White triangle */
    transform: translateX(0.3125em); /* Move triangle slightly to the right */
    }
    
    
    .buttonPauseX {
      width: 3rem;
      height: 3rem;
      display:none;
      flex-direction: row;
      justify-content: center;
      align-content: center;
      align-items: center;
      background-color: var(--bg-color-pause);
      border: 0px solid var(--bg-color-play);
      border-radius: 50%;
    }

    .buttonPause {font-size: 0.8rem;display:none;}
    
    .pause-button {
      position: relative;
      width: 5em;
      height: 5em;
      background-color: #000;
      border-radius: 50%; /* Makes it a circle */
      display: flex;
      justify-content: center;
      align-items: center;
      box-shadowx: 0 0.4em 0.8em rgba(0, 0, 0, 0.2);
    }

    .pause-button::after {
      content: '';
      position: absolute;
      display: flex;
      gap: 0.4em;
    }

    .pause-button div {
      width: 0.5em;
      height: 2.5em;
      background-color: white;
      border-radius: 0.1em;
    }
    .pause-button div:first-of-type {
      margin-right: 0.2rem;

    }
    .pause-button div:last-of-type {
      margin-left: 0.2rem;

    }
    
    
    .mellodyButtons.isPlaying .buttonPlay {
      display:none;
    
    }
    .mellodyButtons.isPlaying .buttonPause {
      display:flex;
    
    }

    .mellodyButtons.active:active, .mellodyButtons.active:hover {   
      background-color: #76b2e9;
    }


    .mellodyButtons.waiting .buttonPlay .play-button-white::after {
      border-color: transparent transparent transparent #dcd9d9; /* White triangle */
      transform: translateX(0.3125em); /* Move triangle slightly to the right */
      font-size: 0.33rem;
    
    }


    
    .mellodyButtons.isClicked .buttonPlay .play-button::after {
      border-color: transparent transparent transparent #8b8b8b;
    }


    .soundButtons {
      position: relative;
      width:100%;
      padding: 0;
      padding-left: 0rem;
      margin: 0;
      display: none;
      margin-top: 0;
      background-color: transparent;
      height:var(--mellody-button-height);
      box-sizing: border-box;
      flex-direction: row;
      justify-content: flex-start;
      align-content: center;
      align-items: center;
      gap:2rem;
    }


    .soundButtons.isPlaying .buttonPlay {
      display:none;
    
    }
    .soundButtons.isPlaying .buttonPause {
      display:flex;
    
    }
    
    .soundButtons.showplayer {
    
      display:flex;
    
    }

    .soundButtonP{
      position:absolute;
      right: 1rem;
      width: 4rem;
      height: 4rem;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-content: center;
      align-items: center;
      background-color: var(--bg-color-play);
      border-radius: 50%;
    
    }
    
    .soundButtonPa{
      position:absolute;
      right: 1rem;
      width: 4rem;
      height: 4rem;
      display:none;
      flex-direction: row;
      justify-content: center;
      align-content: center;
      align-items: center;
      background-color: var(--bg-color-play);
      border-radius: 50%;
    }
    
    
    
    
    .soundButtons.soundOn .soundButtonP {
      display:none;
    
    }
    .soundButtons.soundOn .soundButtonPa {
      display:flex;
    
    }


    .equalizer {
    
    position: relative;
    width: unset;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
    align-items: center;
    z-index: 2;
    bottom: 0;
    right: 0;
    visibility: hidden;
  }

  .soundItemWrapper {
    position: relative;
    width: 22rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
    align-items: center;
    background-color: #bcbe6d;
    height: 70%;
    padding:1rem;
    border-radius: 4px;
    box-sizing: border-box;
    color:#000;

    }
    .soundItem {
      position: relative;
    }




    .box1 {
      position: relative;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-content: flex-start;
      align-items: flex-start;
      z-index: 2;
      margin-top: 0;
      padding-top: 0;
      box-sizing: border-box;
      padding-left: 0;
    }
    .box1wrapper {
      position: relative;
        width: 70%;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-content: flex-start;
        align-items: flex-start;
    }
    .melodyOuther.active .box1 {
    
      padding-top: 0rem;
    
    }
  

    .box3 {
    
      position: relative;
      width: 4.3rem;
      min-width: 77px;
      height: 3.5rem;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-content: center;
      align-items: center;
      background-color: var(--bg-color-vote);
      color: var(--text-color-melody-button);
      border-radius: 100px;
      margin-right: 0;
      font-weight: 700;
      font-size: 1.2rem;
      cursor: pointer;
    }
    .melodyOuther.active .box3 {
    
      display:none;
    
    }
    
    .firstItem {
        font-family: DNSerifVF, Times, "Times New Roman", serif;
        position: relative;
        width: 100%;
        font-size:var(--list-text-size-large);
        font-variation-settings: "opsz" 18;
        color:var(--text-color-melody);
        line-height: 1.1;
        margin-bottom:0rem;
        font-weight: var(--list-text-weight-large);
    
    
    }
    .secondItem {
        position: relative;
        width: 100%;
        font-size:var(--list-text-size-medium);
        color:var(--text-color-artist);
        line-height: 1.1;
        padding-left: var(--divider-small);
        font-weight: var(--list-text-weight-medium);
        
        
    
    }
    .thirdItem {
        position: relative;
        width: 100%;
        font-size:var(--list-text-size-small);
        color:var(--text-color-album);
        line-height: 1.1;
        margin-top:0rem;
        padding-left: var(--divider-small);
        font-weight: var(--list-text-weight-small);
    
    }
    .thirdItem .date {
        color:var(--text-color-date);
    }
    
    .checkboxItem {
        position: relative;
    }
    
    .checkboxwrapper {
        position: relative;
      width: 100%;
      margin: 0;
      padding: 0;
    }
    .checkbox_box {
      display: inline-block;
      padding: 8px;
    
    }

  
    .voteApp {

      position: relative;
      width: 100%;
      height: 100vh;
      min-height: 100vh; 
      display:none;
      align-items: center; /* Valfritt */
      justify-content: center; /* Valfritt */
      box-sizing: border-box;
      overflow: hidden;

    }

    .voteApp.fullscreen {
      display:flex;
    }

    .voteApp.onRealWeb {
      height: unset;
      min-height: unset;
      display: flex;
    }

.over {

      box-sizing: border-box;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      align-content: center;
      background-color: var(--bg-color-vote-box);
      color: #fff;
      font-size: 18px;
      height: 200px !important;
}

    .voteScroller {
      height: 100%; /* Anpassa till önskad höjd inom den yttre div:en */
      width: 100%; /* Anpassa bredd efter behov */
      background-color: var(--bg-color-site);
      overflow-y: scroll; /* Gör vertikal scrolling möjlig */
      scrollbar-width: none; /* Dölj scrollbar i Firefox */
      -ms-overflow-style: none; /* Dölj scrollbar i IE/Edge */
    }


    .voteApp.onRealWeb .voteScroller { 
      height: unset;

    }


    .voteApp.onRealWeb #soundContainer {
      position: relative;

    }

    .voteApp.onRealWeb .voteBoxCloser {

      display:none;

    }

    .voteApp.onRealWeb .voteBarContainer {

      display:none;

    }

    .voteScroller::-webkit-scrollbar {
      display: none;
    }
    

    
    
    .knapp {
      height: 5rem;
      cursor: pointer;
      font-size: 2.1rem;
      background-color: var(--bg-color-vote);
      box-sizing: border-box;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      align-content: center;
      padding: 1rem;
      opacity: 0.4;
      color: #b2afaf;
      border-radius: 100px;
      }
    
    .knapp.active {   
      opacity: 1;
      color: #fff;
      background-color: var(--bg-color-vote);
    }
    .knapp.pulsate.active {   
      animation: pulse 3s infinite ease-in-out; /* Lägg till animation */
    }

    .voteAppMobile .knapp {
      height: 6rem;
    }

    @keyframes pulse {
      0% {
        transform: scale(1);
        box-shadowx: 0 0 5px rgba(235, 1, 17, 0.8);
        background-color: rgba(235, 1, 17, 0.8); /* Färglös ton */
        color: rgba(200, 200, 200,1); /* Dämpad textfärg */
      }
      50% {
        transform: scale(1.15);
        box-shadowx: 0 0 10px rgba(218, 0, 13, 0.8);
        background-color: #da000d; /* Full färg */
        color: rgba(255, 255, 255, 1); /* Full textfärg */
      }
      100% {
        transform: scale(1);
        box-shadowx: 0 0 5px rgba(235, 1, 17, 0.8);
        background-color: rgba(235, 1, 17, 0.8); /* Åter till färglös */
        color: rgba(200, 200, 200, 1); /* Åter till dämpad textfärg */
      }
    }
    
    .knapp.active:active, .knapp.active:hover {   
      background-color: #8fb3c0;
    }
    
    .hideit { color:transparent;}

    .XsvgIconClose {
        width: 3rem;
        height: 3rem;
        fill: rgb(255, 255, 255);
        margin-right: 1rem;
        margin-top: 1rem;
    }
    
    .XsvgIcon {
      width: 60%;
      height: 60%;
      fill: rgb(255, 255, 255);
      margin-left: 5px;
      margin-top: 1px;
    }
    
    .XsvgIconP {
      width: 60%;
      height: 60%;
      fill: rgb(255, 255, 255);
      margin-left: 0px;
      margin-top: 0px;
    }

    .XsvgIconPlay {
      fill: rgb(255, 255, 255);
      margin-top: 1px;
    }
    
    
    .standard-source {
    
      padding-bottom: 20px;
      padding-top: 20px;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
    }
    .noclick {
      pointer-events: none;
    }
    .main__light-mode .standard-source {
      color: #919191;
    }
    
    .eq {
      width: 1.8rem;
    }
    
    .showEq {visibility: visible;}



    /* Stil för låtlistan och spelarfönstret */
    #songList {
        padding: 20px;
        list-style: none;
    }
    .songItem {
        display: flex;
        align-items: center;
        margin: 5px 0;
    }
    .playButton {
        margin-right: 10px;
        cursor: pointer;
        background-color: #28a745;
        color: white;
        padding: 5px 10px;
        border: none;
        border-radius: 3px;
    }


  .verticaldivider {
      position: relative;
      width: 2rem;
  }

  .smalldivider {
      width: var(--divider-small);
  }
  .mediumdivider {
      width: var(--divider-medium);
  }

  .smalltextdivider {
    height: 0.5rem;

  }

  #debugger {

    font-size: 9px;
    line-height: 1;

    display:none;


  }

  .album {
    position: absolute;
    right: 0px;
    top: 0px;
    width: 8rem;
    margin: 1.5rem;

  }

  .voteBoxCloserWrapper {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-content: flex-start;
    align-items: flex-start;
    height: 8rem;
    cursor: pointer;
    z-index: 100;
    background-color: transparent;

  }
  .voteBoxCloser {

    position: relative;
    width: 100%;
    height: 4rem;
    overflow: visible;
    background-color: var(--bg-color-vote-box);

  }

.hideme {
  display:none;
}


    @media screen and (min-width: 420px) {
    
    html,body {
        font-size: 10px;
      }
    
    
      .firstItem {
        font-size:18px;
    }
    .secondItem {
    
        font-size:14px;
    
    
    }
    .thirdItem {
        font-size:14px;
    }

    .voteBox {
      padding-top: 80%;
    }
    
    }


    .littledivider {
      width: 100%;
      height: 1rem;
      background-color: var(--bg-color-vote-box);
    }

    </style>
